import React from "react";
import { ILang } from "../i18n/ILang";
import { IElementsAPI } from "../IElementsAPI";
import { IUser } from "../user/IUser";
import {
  closeMenu,
  closeSearch,
  closeUserMenu,
  NavAction,
  openMenu,
  openSearch,
  openUserMenu,
  setLanguage,
  setShoppingListNumItems,
  setUserLoggedIn,
  setUserLoggedOut
} from "./reducer";

export interface INavAPI {
  setLanguage(lang: ILang): void;
  setUser(user?: IUser): void;
  openMenu(): void;
  closeMenu(): void;
  openSearch(): void;
  closeSearch(): void;
  setShoppingListNumItems(numItems: number): void;
}

export class NavAPI implements INavAPI {
  constructor(public dispatch: React.Dispatch<NavAction>) {}
  setLanguage(lang: ILang): void;
  setLanguage(lang: unknown): void {
    assertIsLang(
      lang,
      "Elements::Nav — Cannot set the language. Make sure language is en, es, or sv."
    );
    this.dispatch(setLanguage(lang));
  }
  setUser(user?: IUser): void;
  setUser(user?: unknown): void {
    if (typeof user === "object") {
      const maybeUser: IUser = {
        firstName: "",
        lastName: "",
        ...user,
        membershipSubscription: {
          status: user["membershipSubscription"]?.status ?? "",
          provider: user["membershipSubscription"]?.provider ?? ""
        }
      };
      this.dispatch(setUserLoggedIn(maybeUser));
    } else {
      this.dispatch(setUserLoggedOut());
    }
  }
  openMenu(): void {
    this.dispatch(openMenu());
  }
  closeMenu(): void {
    this.dispatch(closeMenu());
  }
  openSearch(): void {
    this.dispatch(openSearch());
  }
  closeSearch(): void {
    this.dispatch(closeSearch());
  }
  openUserMenu(): void {
    this.dispatch(openUserMenu());
  }
  closeUserMenu(): void {
    this.dispatch(closeUserMenu());
  }
  setShoppingListNumItems(numItems: number): void {
    assertIsNumber(
      numItems,
      "Elements::Nav — Cannot set the shopping list number of items. Make sure numItems is a number."
    );
    this.dispatch(setShoppingListNumItems(numItems));
  }
}

export const decorateElementsAPI = (
  dispatch: React.Dispatch<NavAction>,
  elements: unknown
): IElementsAPI => {
  return {
    ...(typeof elements === "object" ? elements : {}),
    nav: new NavAPI(dispatch)
  };
};

function assertIsLang(lang: unknown, message: string): asserts lang is ILang {
  if (lang !== "en" && lang !== "es" && lang !== "sv") {
    throw Error(message);
  }
}

function assertIsNumber(numItems: unknown, message: string): asserts numItems is ILang {
  if (typeof numItems !== "number") {
    throw Error(message);
  }
}
